import { useCallback } from 'react';
import { toast } from 'react-toastify';

import api from '@/services/apiSgft';
import { PositionTrainingMatrixFilters } from '@/state/PositionTrainingMatrixFilter.atom';

export const usePositions = (filteredData: PositionTrainingMatrixFilters) => {
	const fetchPositionsByType = useCallback(
		async (
			type: 'mapped' | 'unmapped' | 'blocked' | 'unblocked' | 'all',
			trainingId?: number,
		): Promise<number[]> => {
			try {
				const response = await api.get(
					'position-regulatory-training-link/positions',
					{
						params: {
							type,
							trainingId,
							locations: filteredData.location,
							positions: filteredData.position,
							management: filteredData.management,
							areaCoordination: filteredData.areaCoordination,
							workstation: filteredData.workstation,
						},
					},
				);
				return response.data;
			} catch (error) {
				toast.error('Erro ao carregar funções', {
					theme: 'colored',
					toastId: 'error-positions',
				});
				console.error(error);
				throw error;
			}
		},
		[filteredData],
	);

	return { fetchPositionsByType };
};
